<template>
  <Openhouse class="residential-openhouse" :value="item.openhouses" />
</template>

<script>
import { mapState } from 'vuex'
import Openhouse from '@/components/Openhouse'

export default {
  computed: {
    ...mapState('Residential', ['item']),
  },
  components: {
    Openhouse,
  },
}
</script>
